import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=261e782a&scoped=true&"
import script from "./BrandList.vue?vue&type=script&setup=true&lang=js&"
export * from "./BrandList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261e782a",
  null
  
)

export default component.exports